import { IconButton } from '@calendly/ui/components/icon-button';
import { AddIcon } from '@calendly/ui/components/icons';
import classNames from 'classnames';
import { forwardRef } from 'react';
const addButtonCss = "a1wdjpg2";
export const AddButton = forwardRef((props, ref) => <IconButton ref={ref} {...props} className={classNames(addButtonCss, props.className)}>
    <AddIcon />
  </IconButton>);

require("./add_button.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./add_button.js");